const data = [
    {
        name: 'REACT combined with FIREBASE',
        intro: 'Used React and Firebase as a Backend service to create an Authentication form',
        link: 'https://github.com/nhattanho/selling_market',
        demo: 'https://ecommer-bb4a2.web.app/',
    },
]

export default data;